import { infoSectionModel } from '../Model/InfoSectionModel'

export const infoSectionData: infoSectionModel[] = [
    {
        id: 1,
        src: '/images/children.png',
        alt: 'an illustration of three children holding hand',
        description:
            'Our wooden toys bring endless fun and joy to children,sparking their imagination and creativity.',
        fadeUpDuration: 500,
    },
    {
        id: 2,
        src: '/images/tree.png',
        alt: 'an illustratin of trees',
        description:
            'Crafted from high-quality wood, our toys are sustainably sourced, ensuring durability and a connection to nature.',
        fadeUpDuration: 1000,
    },
    {
        id: 3,
        src: '/images/puzzle.png',
        alt: 'an illustration of a 4 piece puzzle',
        description:
            'Our wooden puzzles encourage problem-solving skills and cognitive development in a playful, engaging way.',
        fadeUpDuration: 1500,
    },
]
